import {userService} from '../../services/user';
import {ck, interact} from 'fire-wind-water';
import {user} from './user';
import {settings} from '../../common/setting';

export async function getCookieId() {
  if (!user.globalUserId) {
    const info = {
      clientBrand: interact.browseInfo.browser,
      clientIP: '127.0.0.1',
      clientType: interact.browseInfo.browser,
      clientVersion: interact.browseInfo.os
    };
    await userService.getIP().then(res => {
      info.clientIP = res.returnCitySN.cip;
      settings.clientIP = info.clientIP;
    });
    await new Promise(resolve => {
      userService.getId(info, (res) => {
        resolve(res);
      });
    }).then((res => {
      user.globalUserId = res.content;
    }));
    ck.cookie('globalUserId', user.globalUserId, {path: '/', domain: 'smarket.net.cn', expires: 365});
  }

  // 返回Promise, 方便外部同步调用，到这里不用等promise返回，在user中已经存在
  return new Promise(resolve => {
    resolve(user.globalUserId);
  });
}

export function removeCookieId(){
  ck.removeCookie('globalUserId', {path: '/', domain: 'smarket.net.cn'});
}